import { useEffect, useState } from 'react'

function DiscordWidget() {
  const [onlineCount, setOnlineCount] = useState<number | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    async function refresh() {
      try {
        const response = await fetch('https://discord.com/api/guilds/1325522814895263775/widget.json', { signal: controller.signal })
        if (!response.ok) throw new Error('Widget unavailable')
        const data: { presence_count?: unknown } = await response.json()
        const count = data?.presence_count
        if (!controller.signal.aborted) setOnlineCount(typeof count === 'number' && Number.isInteger(count) && count >= 0 ? count : null)
      } catch {
        if (!controller.signal.aborted) setOnlineCount(null)
      }
    }
    void refresh()
    const interval = setInterval(() => void refresh(), 5 * 60 * 1000)
    return () => { controller.abort(); clearInterval(interval) }
  }, [])

  return (
    <aside id="discord-widget" className="ac-discord" aria-labelledby="discord-title">
      <img src="/favicon.svg" alt="" width="64" height="64" />
      <h2 id="discord-title">Stav se<br />na Discord.</h2>
      <p>Jsme tam. Když ti to sedí, přidej se.</p>
      {onlineCount !== null && <p className="ac-presence" role="status">{onlineCount.toLocaleString('cs-CZ')} online</p>}
      <a href="https://discord.allcom.zone" target="_blank" rel="noopener noreferrer">discord.allcom.zone</a>
    </aside>
  )
}

export default DiscordWidget
